import { createFileRoute } from '@tanstack/react-router';
import { PerformanceListPage } from '@/pages/performance/PerformanceListPage';

export const Route = createFileRoute('/performance/')({
  component: PerformanceListPage,
});
